import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { uplodateLoading, updateTopHeader } from '../../../redux/features/common/commonSlice';
import urls from '../../constants/apiurl';
import ApiCaller from '../../constants/ApiCaller';
import { showDangerToast } from '../../constants/toaster';
import { Box, Pagination, Button, TextField, Typography } from '@mui/material';
import NavBar from '../../structure/NavBar';
import { NavBarTop } from '../../structure/NavBarTop';
import InsufficientPermission from '../../custom/InSufficientPermission';
import InputGroup from 'react-bootstrap/InputGroup';
import Form from 'react-bootstrap/Form';
import { v4 as uuidv4 } from 'uuid';
import { formatIndianNumber } from '../../lib/formatIndianNumber';
import { getWithdrawUserName, getWithdrawTxnId } from '../../lib/withdrawDisplay';
import * as XLSX from 'xlsx-js-style';
import { saveAs } from 'file-saver';

const UserBankWithdrawHistory = () => {
  const dispatch = useDispatch();
  const userData = useSelector(state => state?.userData);
  const userPermisiions = useSelector(state => state?.permission);
  const navigate = useNavigate();
  const { userId } = useParams();

  let currentModulePermission;
  let viewPermission = true;
  if (userPermisiions?.modules?.length > 0) {
    currentModulePermission = userPermisiions.modules.find((element) => element.moduleId === '31')?.permissions;
    if (currentModulePermission) {
      viewPermission = currentModulePermission.find((element) => element.name === 'VIEW')?.isEnable;
    }
  }

  const [datalist, setDatalist] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSizeInput, setPageSizeInput] = useState(25);
  const [callAPi, setCallAPi] = useState('');

  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [status, setStatus] = useState('ALL');
  const [searchText, setSearchText] = useState('');

  const [pagerecord, setPagerecord] = useState({
    totalItems: 0,
    pageNumber: 1,
    pageSize: 10,
    totalPages: 1
  });

  useEffect(() => {
    dispatch(updateTopHeader('User Bank Withdraw History'));
  }, [dispatch]);

  useEffect(() => {
    if (!userId) return;
    getWithdrawHistory();
    // eslint-disable-next-line
  }, [page, callAPi, userId]);

  const handlePageSizeInputChange = (e) => setPageSizeInput(e.target.value);

  const handlePageSizeSubmit = () => {
    let val = Number(pageSizeInput);
    if (val < 1 || isNaN(val)) val = 25;
    else if (val > 500) val = 500;

    setPageSizeInput(val);
    if (val !== pagerecord.pageSize) {
      setPagerecord(prev => ({ ...prev, pageNumber: 1, pageSize: val }));
      setPage(1);
      setCallAPi(uuidv4());
    }
  };

  const formatAmount = (amount) => {
    if (!amount) return 0;
    const num = Number(amount);
    return (num - Math.floor(num)) <= 0.5 ? Math.floor(num) : Math.ceil(num);
  };

  const getWithdrawHistory = async () => {
    try {
      dispatch(uplodateLoading(true));
      let postJson = {
        sort: 'createdAt',
        order: false,
        page: page - 1,
        limit: pagerecord.pageSize,
        txnId: '',
        search: '',
        startDate: startDate || null,
        toUserId: userId,
        endDate: endDate || null,
        status: status === 'ALL' ? '' : status
      };

      let res = await ApiCaller.post(postJson, urls.bankWithdrawHistory, userData?.access_token);
      const response = await res.response.json();
      const apiData = response.data && response.data.data ? response.data.data : response.data;

      if (['OK', 200, '200'].includes(response.status) || response.code === '200') {
        dispatch(uplodateLoading(false));
        setDatalist(
          Array.isArray(apiData?.items)
            ? apiData.items
            : Array.isArray(apiData?.records)
              ? apiData.records
              : []
        );
        setPagerecord({
          totalItems: apiData.totalItems || apiData.totalRecords || 0,
          totalPages: apiData.totalPages || 1,
          pageNumber: typeof apiData.pageNumber === 'number' ? apiData.pageNumber + 1 : page,
          pageSize: apiData.pageSize || pagerecord.pageSize
        });
      } else {
        dispatch(uplodateLoading(false));
        showDangerToast(response.message || 'Something went wrong');
      }
    } catch (error) {
      dispatch(uplodateLoading(false));
      showDangerToast(error.message);
    }
  };

  if (!viewPermission) {
    return <InsufficientPermission />;
  }

  return (
    <>
      <NavBar />
      <div className='main-content'>
        <NavBarTop />
        <div className='header'>
          <div className='logo'>
            <div className='header bg-gradient-primary pb-8 pt-5 pt-md-8'></div>
          </div>
        </div>

        <div className='container-fluid mt--7'>
          <div className='row'>
            <div className='col text-left'>
              <div className='card shadow mb-4'>
                <div className='card-header border-0'>
                  <div className='d-flex justify-content-between align-items-center mb-3'>
                    <h3 className='mb-0'>User Bank Withdraw History</h3>
                    <Button
                      variant='outlined'
                      size='small'
                      onClick={() => navigate('/user-manager')}
                    >
                      Back
                    </Button>
                  </div>
                  <div className='row align-items-center text-left'>
                    <div className='col-md-3 mb-2'>
                      <InputGroup className='mb-2' style={{ borderRadius: '10px' }}>
                        <Form.Control
                          placeholder='Search by User Name'
                          value={searchText}
                          onChange={(e) => setSearchText(e.target.value)}
                          style={{ height: '40px' }}
                        />
                      </InputGroup>
                    </div>

                    <div className='col-md-3 mb-2'>
                      <TextField
                        type='date'
                        label='Start Date'
                        InputLabelProps={{ shrink: true }}
                        value={startDate}
                        onChange={(e) => setStartDate(e.target.value)}
                        fullWidth
                        size='small'
                      />
                    </div>

                    <div className='col-md-3 mb-2'>
                      <TextField
                        type='date'
                        label='End Date'
                        InputLabelProps={{ shrink: true }}
                        value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                        fullWidth
                        size='small'
                      />
                    </div>

                    <div className='col-md-2 mb-2'>
                      <Form.Select value={status} onChange={(e) => setStatus(e.target.value)} style={{ height: '40px' }}>
                        <option value='ALL'>All Status</option>
                        <option value='PENDING'>Pending</option>
                        <option value='PROCESSING'>Processing</option>
                        <option value='PAID'>Paid</option>
                        <option value='REJECTED'>Rejected</option>
                      </Form.Select>
                    </div>

                    <div className='col-md-1 mb-2'>
                      <Button
                        variant='contained'
                        onClick={() => {
                          setPage(1);
                          setCallAPi(uuidv4());
                        }}
                        fullWidth
                      >
                        Filter
                      </Button>
                    </div>
                  </div>

                  <div className='row'>
                    <div className='col-md-12 text-right'>
                      <Button
                        variant='text'
                        onClick={() => {
                          setSearchText('');
                          setStatus('ALL');
                          setStartDate('');
                          setEndDate('');
                          setPage(1);
                          setCallAPi(uuidv4());
                        }}
                      >
                        Reset Filters
                      </Button>
                    </div>
                  </div>
                </div>

                <div className='card-body'>
                  <div className='table-responsive'>
                    <table className='table align-items-center table-flush'>
                      <thead className='thead-light'>
                        <tr>
                          <th>#</th>
                          <th>User Name</th>
                          <th>Transaction ID</th>
                          <th>Requested Amt</th>
                          <th>Final Amt</th>
                          <th>Bank Name</th>
                          <th>Account No</th>
                          <th>IFSC</th>
                          <th>Date</th>
                          <th>Status</th>
                          <th>Remarks</th>
                        </tr>
                      </thead>
                      <tbody>
                        {Array.isArray(datalist) && datalist.length > 0
                          ? datalist
                              .filter((item) => {
                                if (!searchText) return true;
                                const name = getWithdrawUserName(item);
                                return name !== '-' && name.toLowerCase().includes(searchText.toLowerCase());
                              })
                              .map((item, idx) => (
                                <tr key={item?.id || idx}>
                                  <td>{(pagerecord.pageNumber - 1) * pagerecord.pageSize + idx + 1}</td>
                                  <td>{getWithdrawUserName(item)}</td>
                                  <td style={{ fontSize: '0.85rem', wordBreak: 'break-all' }}>{getWithdrawTxnId(item)}</td>
                                  <td>{formatIndianNumber(item?.requestedAmount)}</td>
                                  <td>{formatIndianNumber(item?.finalAmount)}</td>
                                  <td>{item?.bankName || '-'}</td>
                                  <td>{item?.accountNumber || item?.bankAccount || '-'}</td>
                                  <td>{item?.ifscCode || item?.ifsc || '-'}</td>
                                  <td>{item?.createdAt || item?.createdDate || item?.date || '-'}</td>
                                  <td>
                                    <span
                                      className={`badge font-weight-bold ${
                                        item?.status === 'PAID'
                                          ? 'badge-success'
                                          : item?.status === 'REJECTED'
                                            ? 'badge-danger'
                                            : item?.status === 'PROCESSING'
                                              ? 'badge-info'
                                              : 'badge-primary'
                                      }`}
                                    >
                                      <span className='text-white'>{item?.status || 'PENDING'}</span>
                                    </span>
                                  </td>
                                  <td>{item?.remarks || '-'}</td>
                                </tr>
                              ))
                          : (
                            <tr>
                              <td colSpan={11} className='text-center'>
                                No Data Found
                              </td>
                            </tr>
                          )}
                      </tbody>
                    </table>
                  </div>

                  <Box display='flex' justifyContent='flex-end' alignItems='center' mt={3}>
                    <Box display='flex' alignItems='center'>
                      <span style={{ marginRight: '10px' }}>Page Size:</span>
                      <TextField
                        type='number'
                        inputProps={{ min: 1, max: 500 }}
                        value={pageSizeInput}
                        onChange={handlePageSizeInputChange}
                        onBlur={handlePageSizeSubmit}
                        onKeyDown={(e) => e.key === 'Enter' && handlePageSizeSubmit()}
                        size='small'
                        sx={{ mr: 3, width: 80 }}
                      />
                      <span style={{ marginRight: '15px' }}>Total: {pagerecord?.totalItems}</span>
                      <Pagination
                        count={pagerecord?.totalPages}
                        page={page}
                        onChange={(e, v) => setPage(v)}
                        color='primary'
                        showFirstButton
                        showLastButton
                      />
                    </Box>
                  </Box>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserBankWithdrawHistory;

